import { render, staticRenderFns } from "./TickspeedAutobuyerBox.vue?vue&type=template&id=c3aa3a12&scoped=true&"
import script from "./TickspeedAutobuyerBox.vue?vue&type=script&lang=js&"
export * from "./TickspeedAutobuyerBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aa3a12",
  null
  
)

export default component.exports